import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {NavsearchComponent} from './header/navsearch/navsearch.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {UserblockComponent} from './sidebar/userblock/userblock.component';
import {UserblockService} from './sidebar/userblock/userblock.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {LayoutComponent} from './layout.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule
  ],
  exports: [
    TranslateModule,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    UserblockComponent,
    NavsearchComponent,
    LayoutComponent
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    NavsearchComponent,
    SidebarComponent,
    UserblockComponent,
    LayoutComponent
  ],
  providers: [UserblockService]
})
export class LayoutModule {
}
